import gql from 'graphql-tag';

import {
  UserProfileFragment,
  EducationProfileFragment,
  ShortMockExamStudentProfileFragment,
} from '../fragments/MyProfileFragment';

export const profile = gql`
  query myProfileQuery($educationYear: Int!, $roundCode: ID!) {
    myProfile {
      id
      userDetails {
        ...UserProfileFragment
      }
      educationProfiles(educationYear: $educationYear) {
        ...EducationProfileFragment
      }
    }
    mockExamSchoolRound(mockExamRoundCode: $roundCode) {
      roundId
      roundCode
      title
      isActive
      enabledSchoolRegistration
    }
    mockExamStudentProfile(mockExamRoundCode: $roundCode) {
      ...ShortMockExamStudentProfileFragment
    }
  }
  ${UserProfileFragment}
  ${EducationProfileFragment}
  ${ShortMockExamStudentProfileFragment}
`;

export const profileWithLocationCode = gql`
  query myProfileWithLocationCode($educationYear: Int!, $locationCode: ID!, $roundCode: ID!) {
    myProfile {
      id
      userDetails {
        ...UserProfileFragment
      }
      educationProfiles(educationYear: $educationYear) {
        ...EducationProfileFragment
      }
    }

    mockExamSchool(mockExamLocationCode: $locationCode) {
      locationId
      locationCode
      locationName
    }

    mockExamSchoolRound(mockExamRoundCode: $roundCode) {
      roundId
      roundCode
      title
      isActive
      enabledSchoolRegistration
    }
    mockExamStudentProfile(mockExamRoundCode: $roundCode) {
      ...ShortMockExamStudentProfileFragment
    }
  }
  ${UserProfileFragment}
  ${EducationProfileFragment}
  ${ShortMockExamStudentProfileFragment}
`;

export const activeExamRound = gql`
  query mockExamSchoolActiveRound {
    mockExamSchoolActiveRound {
      roundId
      roundCode
    }
  }
`;
